import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAppState } from "../../redux/slices/appState";
import { ChevronRight } from "lucide-react";
import CategoryConfiguration from "./CategoryConfiguration";
import SubCategoryConfiguration from "./SubCategoryConfiguration";
import ProductTagsConfiguration from "./ProductTagsConfiguration";
import VendorTagsConfiguration from "./VendorTagsConfiguration";
import CouponTagsConfiguration from "./CouponTagsConfiguration";
import AdminsConfiguration from "./AdminsConfiguration";
import ServiceTypesConfiguration from "./ServiceTypesConfiguration";
import { MdOutlineMenu } from "react-icons/md";
import { HiOutlineX } from "react-icons/hi";

const AdminConfigurationPage: React.FC = () => {
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(6);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const formStepOptions = [
    {
      title: "Admin",
      id: 6,
    },
    {
      title: "Service Types",
      id: 7,
    },
    {
      title: "Categories",
      id: 1,
    },
    {
      title: "Subcategories",
      id: 2,
    },
    {
      title: "Vendor Tags",
      id: 4,
    },
    {
      title: "Product Tags",
      id: 3,
    },
    {
      title: "Coupons",
      id: 5,
    },
  ];

  return (
    <div className="">
      <div className="bg-bgColor max-h-screen">
        <div className="flex mb-1 pr-4 overflow-hidden bg-bgColor relative">
          <button
            className="hidden max-[1523px]:block absolute top-4 left-4 z-10"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? <></> : <MdOutlineMenu className="w-6 h-6" />}
          </button>

          <div
            className={`col-span-2 px-6 pb-6 pt-2 min-w-52 max-[1523px]:fixed max-[1523px]:left-0 max-[1523px]:top-0 max-[1523px]:bg-white max-[1523px]:h-screen max-[1523px]:overflow-y-auto max-[1523px]:z-50 max-[1523px]:shadow-lg ${
              isSidebarOpen
                ? "max-[1523px]:translate-x-0"
                : "max-[1523px]:-translate-x-full"
            } transition-transform duration-300 ease-in-out`}
          >
            <div className="flex justify-end">
              <button
                className="hidden max-[1523px]:block pl-2"
                onClick={() => setIsSidebarOpen(false)}
              >
                <HiOutlineX className="w-6 h-6 text-customGray" />
              </button>
            </div>

            <div className="w-full">
              {formStepOptions.map((option) => (
                <div
                  key={option.id}
                  className="flex items-center justify-between py-3"
                >
                  <span
                    className={`cursor-pointer flex justify-between w-full text-sm font-normal ${
                      selectedButtonIndex === option.id
                        ? "text-customGreenColor font-helveticaMedium"
                        : "text-customGrayDark"
                    }`}
                    onClick={() => {
                      setSelectedButtonIndex(option.id);
                      setIsSidebarOpen(false);
                    }}
                  >
                    <span className="text-left">{option.title}</span>
                    <ChevronRight
                      className="mt-[0.2rem] w-4 h-4"
                      color={
                        selectedButtonIndex === option.id
                          ? "#008000"
                          : "#BEC0CA"
                      }
                    />
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full pt-2 overflow-hidden h-full max-[1523px]:ml-12">
            {selectedButtonIndex === 1 ? (
              <CategoryConfiguration />
            ) : selectedButtonIndex === 2 ? (
              <SubCategoryConfiguration />
            ) : selectedButtonIndex === 3 ? (
              <ProductTagsConfiguration />
            ) : selectedButtonIndex === 4 ? (
              <VendorTagsConfiguration />
            ) : selectedButtonIndex === 5 ? (
              <CouponTagsConfiguration />
            ) : selectedButtonIndex === 6 ? (
              <AdminsConfiguration />
            ) : selectedButtonIndex === 7 ? (
              <ServiceTypesConfiguration />
            ) : (
              <ServiceTypesConfiguration />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminConfigurationPage;
